import * as React from 'react';

export function BellSvg(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" {...props}>
      <title>{'126 bell'}</title>
      <path d="M22.555 13.662l-1.9-6.836A9.321 9.321 0 002.576 7.3l-1.471 6.615A5 5 0 005.986 20H7.1a5 5 0 009.8 0h.838a5 5 0 004.818-6.338zM12 22a3 3 0 01-2.816-2h5.632A3 3 0 0112 22zm8.126-5.185A2.977 2.977 0 0117.737 18H5.986a3 3 0 01-2.928-3.651l1.47-6.616a7.321 7.321 0 0114.2-.372l1.9 6.836a2.977 2.977 0 01-.502 2.618z" />
    </svg>
  );
}
